import api from './axiosInstance';

/**
 * Auditoría de correos/WhatsApp salientes EEPP.
 *
 * Backend: EscriturasOutboundController (api/escrituras/outbound). Registra cada
 * mensaje saliente (intake inicial, recordatorios, acuses, alta manual) con su
 * estado (sent/failed/bounced/queued/stub), motivo de falla/rebote y, cuando
 * aplica, la escritura a la que pertenece. La vista "Log de Correos" y la línea
 * de estado por escrito en EEPP BETA consumen estos endpoints.
 *
 * Forma del DTO (OutboundMessageDto):
 *   { id, caseId, escrituraId, channel, toIdentifier, templateKey,
 *     templateLabel, status, errorMessage, bounceReason, sentAt }
 */

/**
 * Log global de correos salientes. Por defecto el backend devuelve solo los
 * problemáticos (failed,bounced,queued); pasa status='all' para ver todos, o un
 * valor puntual (sent/failed/bounced/queued). `channel` filtra email|whatsapp.
 */
export const getOutboundLog = async ({ status, channel, take, skip } = {}, signal) => {
  const response = await api.get('/escrituras/outbound', {
    params: { status, channel, take, skip },
    signal,
  });
  return response.data || [];
};

/**
 * Salientes de un caso (orden más reciente primero). Alimenta la línea de estado
 * por escrito y la "última comunicación" a nivel caso en EEPP BETA.
 */
export const getCaseOutbound = async (caseId, signal) => {
  if (!caseId) return [];
  const response = await api.get(`/escrituras/outbound/case/${caseId}`, { signal });
  return response.data || [];
};

/**
 * Reenvía un mensaje saliente fallido/rebotado. Si se pasa email/whatsapp, el
 * backend corrige el contacto del cliente en el CRM (Clients_SAAS) y reenvía al
 * dato corregido; sin body reenvía al contacto vigente. Crea una fila NUEVA (la
 * original queda como registro fallido) y devuelve su DTO.
 */
export const resendOutbound = async (messageId, { email, whatsapp } = {}, signal) => {
  const response = await api.post(
    `/escrituras/outbound/${messageId}/resend`,
    { email: email ?? null, whatsapp: whatsapp ?? null },
    { signal }
  );
  return response.data;
};
